import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { addAttachmentPoi, addTextAttachmentPoi, createPoi, deletePoi, getLocation } from "../api/dashboardAPI";
import Loader from "../components/Loader";
import Modal from "react-modal";

import { downloadFileIcon, plusIcon, closeModalIcon, deleteIcon, imageIcon, videoIcon, audioIcon, fileIcon } from "../components/Icons";
import { languages } from "../components/Constants";

const SingleLocation = (props) => {
  const { token } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  const [location, setLocation] = useState();
  const [poiIdToDelete, setPoiIdToDelete] = useState(0);

  const { id } = useParams();

  const [isPoisModalOpen, setIsPoisModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const openPoisModal = () => {
    setIsPoisModalOpen(true);
  };

  const closePoisModal = () => {
    setIsPoisModalOpen(false);
  };

  const openDeletePoiModal = (id) => {
    setPoiIdToDelete(id);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleCreatePoiClick = (e) => {
    e.preventDefault();
    setLoading(true);

    const formDataInput = new FormData(e.currentTarget);
    const data = new FormData();
    const groupedData = {};
    for (const [key, value] of formDataInput.entries()) {
      if (key !== "attachment" && key !== "textAttachments") {
        groupedData[key] = value;
      }
    }

    Object.keys(groupedData).forEach(key => {
      data.append(key, JSON.stringify(groupedData[key]));
    });

    //Attachments
    const attachmentsData = [];
    const attachmentFiles = e.currentTarget.attachments;
    const attachmentType = e.currentTarget.attachmentType.value;

    attachmentFiles.forEach((attachmentFile, index) => {
      const file = attachmentFile.files[0];

      if(!file)
        return;

      attachmentsData.push({
        language: languages[index].slug,
        attachmentType: attachmentType,
        attachment: file
      });
    });

    //Text attachments
    const textAttachmentsData = [];
    const textAttachmentFiles = e.currentTarget.textAttachments;

    textAttachmentFiles.forEach((attachmentFile, index) => {
      const file = attachmentFile.files[0];

      if(!file)
        return;

      textAttachmentsData.push({
        language: languages[index].slug,
        format: file.name.split(".")[1],
        textAttachment: file
      });
    });

    createPoi(token, id).then((res) => {
      //Carico gli allegati
      const textAttachmentPromises = textAttachmentsData.map(attachment => {
      var textAttachmentsFormData = new FormData();
      textAttachmentsFormData.append("language", attachment.language);
      textAttachmentsFormData.append("format", attachment.format);
      textAttachmentsFormData.append("textAttachment", attachment.textAttachment);
      return addTextAttachmentPoi(token, textAttachmentsFormData, res.id);
    });
    
    return Promise.all(textAttachmentPromises).then(() => res);
  }).then((res) => {
    // Then upload regular attachments (in parallel among themselves)
    const attachmentPromises = attachmentsData.map(attachment => {
      var attachmentsFormData = new FormData();
      attachmentsFormData.append("language", attachment.language);
      attachmentsFormData.append("attachmentType", attachment.attachmentType);
      attachmentsFormData.append("attachment", attachment.attachment);
      return addAttachmentPoi(token, attachmentsFormData, res.id);
    });
    
    return Promise.all(attachmentPromises);
    }).then(() => {
        closePoisModal(); 
        getLocation(token, id).then((res) => {
          setLocation(res);
          setLoading(false);
      });
    });
  };

  const handleDeleteClick = (e, poisId) => {
    e.preventDefault();
    setLoading(true);
    deletePoi(token, poisId).then(() => {
      closeDeleteModal(); 
      getLocation(token, id).then((res) => {
        setLocation(res);
        setLoading(false);
      });
    });
  };

  useEffect(() => {
    getLocation(token, id).then(async (res) => {
      setLocation(res);
      setLoading(false);
    });
  }, [token, id]);

  const fileTypeSwitch = (type) => {
    switch(type) {
      case 'IMAGE':
        return imageIcon;
      case 'VIDEO':
        return videoIcon;
      case 'AUDIO':
        return audioIcon;
      default:
        return fileIcon;
    }
  }

  return loading ? (
    <Loader />
  ) : (
    <>
      <div>
        <div className="font-bold text-xl">Dettaglio località "{location.nome.translations[0].text}"</div>
        {location.imageUrl && (
          <div className="w-[25%] mt-4 mb-6">
            <img className="rounded-xl shadow-md shadow-[#FFFFFF]" src={location.imageUrl} alt="Immagine della località"></img>
          </div>
        )}
        <table className="w-full bg-[linear-gradient(180deg,_rgba(1,74,74,0.70)_0%,rgba(20,20,20,1)_100%)] rounded-lg customShadow shadow-[#003333]">
          <tr className="border-b-2">
            <th className="border-r-2"></th>
            {languages.map((lang) => (
              <th className="pt-4 pb-4 pl-6 text-left" style={{width: `${100 / languages.length}%`}}>{lang.value.charAt(0).toUpperCase() + lang.value.slice(1)}</th>
            ))}
          </tr>
          <tr>
            <th className="pt-4 pb-4 pl-6 pr-6 text-left border-r-2">Nome</th>
            {languages.map((lang) => (
              <td className="pl-6 pr-6 pt-2 pb-2" style={{width: `${100 / languages.length}%`}}>
                {location.nome.translations.map((translation) => (
                  translation.language === lang.slug &&
                  <p className="whitespace-normal">{translation.text}</p>
                ))}
              </td>
            ))}
          </tr>
          <tr>
            <th className="pt-4 pb-4 pl-6 pr-6 text-left border-r-2">Località</th>
            {languages.map((lang) => (
              <td className="pl-6 pr-6 pt-2 pb-2" style={{width: `${100 / languages.length}%`}}>
                {location.localita.translations.map((translation) => (
                  translation.language === lang.slug &&
                  <p className="whitespace-normal">{translation.text}</p>
                ))}
              </td>
            ))}
          </tr>
          <tr>
            <th className="pt-4 pb-4 pl-6 pr-6 text-left border-r-2">Paese</th>
            {languages.map((lang) => (
              <td className="pl-6 pr-6 pt-2 pb-2" style={{width: `${100 / languages.length}%`}}>
                {location.paese.translations.map((translation) => (
                  translation.language === lang.slug &&
                  <p className="whitespace-normal">{translation.text}</p>
                ))}
              </td>
            ))}
          </tr>
          <tr>
            <th className="pt-4 pb-4 pl-6 pr-6 text-left border-r-2">Descrizione</th>
            {languages.map((lang) => (
              <td className="pl-6 pr-6 pt-2 pb-2" style={{width: `${100 / languages.length}%`}}>
                {location.descrizione.translations.map((translation) => (
                  translation.language === lang.slug &&
                  <p className="whitespace-normal">{translation.text}</p>
                ))}
              </td>
            ))}
          </tr>
          <tr>
            <th className="pt-4 pb-4 pl-6 pr-6 text-left border-r-2">Descrizione finale</th>
            {languages.map((lang) => (
              <td className="pl-6 pr-6 pt-2 pb-2" style={{width: `${100 / languages.length}%`}}>
                {location.descrizioneFinale.translations.map((translation) => (
                  translation.language === lang.slug &&
                  <p className="whitespace-normal">{translation.text}</p>
                ))}
              </td>
            ))}
          </tr>
        </table>
        <div className="flex items-center justify-between mt-4 mb-4">
          <p>Punti di interesse:</p>
          <button className="flex flex-cols-[auto_2fr] gap-1 bg-[#007474] rounded-xl pl-2 pr-2 h-8 cursor-pointer justify-center items-center text-xs transition duration-300 ease-in-out hover:bg-[#008585]" onClick={openPoisModal}>
            <div className="aspect-square w-6">{plusIcon}</div>
            <p>Aggiungi punto di interesse</p>
          </button>
        </div>
        <table className="w-full bg-[linear-gradient(180deg,_rgba(1,74,74,0.70)_0%,rgba(20,20,20,1)_100%)] rounded-lg customShadow shadow-[#003333]">
          <tr className="border-b-2">
            <th className="p-4">Id</th>
            <th className="p-4">Token</th>
            <th className="p-4">Allegato</th>
            <th className="p-4">Allegati testuali</th>
            <th className="p-4"></th>
          </tr>
          {location.pois && location.pois.length > 0 ? (
            location.pois.map((pos) => (
              <tr className="text-center">
                <td className="p-4">{pos.id}</td>
                <td className="p-4">{pos.token}</td>
                <td className="p-4">
                  <div className="flex flex-col gap-2 pl-6 pr-6">
                    {pos.attachments.map((attachment) => (
                      <div className="grid grid-cols-2 items-center justify-around">
                        {attachment.language.toUpperCase()}:
                        <a className="flex flex-col items-center cursor-pointer" href={attachment.url} rel="noreferrer" target="_blank">
                          <div className="aspect-square w-6">
                            {fileTypeSwitch(attachment.type)}
                          </div>
                          <p className="text-xs">{attachment.type}</p>
                        </a>
                      </div>
                    ))}
                  </div>
                </td>
                <td className="p-4">
                  <div className="flex flex-col gap-2 pl-6 pr-6">
                    {pos.textAttachments.map((attachment => 
                      <div className="flex items-center justify-around">
                        {attachment.language.toUpperCase()}:
                        <a className="flex flex-col items-center cursor-pointer" href={attachment.url}>
                          <div className="aspect-square w-6">{downloadFileIcon}</div>
                          <p className="text-xs">.{attachment.format}</p>
                        </a>
                      </div>
                    ))}
                  </div>
                </td>
                <td className="pl-6 pr-6 pt-2 pb-2" align="center">
                  <div className="flex align-center justify-center">
                    <button className="w-5 bg-[#007474] p-2 rounded-xl cursor-pointer justify-center items-center transition duration-300 ease-in-out hover:bg-[#008585]" onClick={() => openDeletePoiModal(pos.id)} title="Elimina punto di interesse">{deleteIcon}</button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5}>
                <p className="p-4 text-center">
                  Nessun punto di interesse trovato
                </p>
              </td>
            </tr>
          )}
        </table>
      </div>

      <Modal
        isOpen={isPoisModalOpen}
        onRequestClose={closePoisModal}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
          },
        }}
        contentLabel="Aggiungi punto di interesse"
      >
        <div className="bg-[#141414] h-full flex flex-col gap-4 p-6">
          <div className="flex w-full h-8 justify-between items-center">
            <p className="text-xl">Aggiungi punto di interesse</p>
            <button className="aspect-square w-8 cursor-pointer transition duration-100 ease-in-out hover:scale-110" onClick={closePoisModal}>{closeModalIcon}</button>
          </div>
          <div>
            <form className="flex flex-col gap-8" style={{width: "30rem"}} onSubmit={(e) => handleCreatePoiClick(e)}>
              <div className="flex flex-col gap-2">
                <p className="italic">Allegati</p>
                <div className="flex gap-4 mb-4">
                  <p>Tipologia:</p>
                  <select className="pl-2 pr-2 rounded bg-transparent" name="attachmentType">
                    {/*<option value="IMAGE">Immagine</option>
                      <option value="AUDIO">Audio</option>*/}
                    <option value="VIDEO">Video</option>

                  </select>
                </div>
                {languages.map((lang) => (
                  <div className="flex justify-between">
                    <p>{lang.value.charAt(0).toUpperCase() + lang.value.slice(1)}:</p>
                    <input
                      type="file"
                      accept="image/png, video/mp4, audio/mp3"
                      name="attachments"
                    ></input>
                  </div>
                ))}
              </div>
              <div className="flex flex-col gap-2">
                <p className="italic">Allegati testuali</p>
                {languages.map((lang) => (
                  <div className="flex justify-between">
                    <p>{lang.value.charAt(0).toUpperCase() + lang.value.slice(1)}:</p>
                      <input
                        type="file"
                        accept=".lrc"
                        name="textAttachments"
                      ></input>
                  </div>
                ))}
              </div>
              <div className="flex justify-center items-center gap-1 mt-3">
                <button className="flex flex-cols-[auto_2fr] gap-1 bg-[#007474] rounded-xl pl-6 pr-6 h-8 text-xs cursor-pointer justify-center items-center transition duration-300 ease-in-out hover:bg-[#008585]">
                  <p>Conferma</p>
                </button>
              </div>
            </form>
          </div>
        </div>
    </Modal>
    <Modal
      isOpen={isDeleteModalOpen}
      onRequestClose={closeDeleteModal}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        },
      }}
      contentLabel="Elimina punto di interesse"
    >
      <div className="bg-[#141414] h-full flex flex-col gap-4 p-6">
        <div className="flex w-full h-8 justify-between items-center">
          <p className="text-xl">Elimina punto di interesse</p>
          <button className="aspect-square w-8 cursor-pointer transition duration-100 ease-in-out hover:scale-110" onClick={closeDeleteModal}>{closeModalIcon}</button>
        </div>
        <div>
          <form>
            <p>Sei sicuro di voler eliminare il punto di interesse '{poiIdToDelete}'?</p>
            <div className="flex justify-center items-center gap-1 mt-3">
              <button className="flex flex-cols-[auto_2fr] gap-1 bg-[#007474] rounded-xl pl-6 pr-6 h-8 text-xs cursor-pointer justify-center items-center transition duration-300 ease-in-out hover:bg-[#008585]" onClick={(e) => handleDeleteClick(e, poiIdToDelete)}>
                <p>Conferma</p>
              </button>
            </div>
          </form>
        </div>
      </div>
  </Modal>
    </>
  );
};

export default SingleLocation;